import React, { memo } from 'react';
import { motion } from 'framer-motion';
const modules = [{
  icon: '🧠',
  number: 'Módulo 1',
  title: 'Memoria Estratégica PRO',
  desc: 'Actividades intensivas para fortalecer memoria visual, auditiva y secuencial con material listo para aplicar.',
  ideal: 'Dislexia, lectoescritura y TDAH'
}, {
  icon: '🎯',
  number: 'Módulo 2',
  title: 'Foco Total PRO',
  desc: 'Recursos prácticos para trabajar atención, concentración y control de distractores en sesiones más efectivas.',
  ideal: 'TDAH y lectoescritura'
}, {
  icon: '🗣️',
  number: 'Módulo 3',
  title: 'Lenguaje Estratégico PRO',
  desc: 'Propuestas funcionales para ampliar vocabulario, mejorar comprensión y potenciar la expresión oral.',
  ideal: 'Dislexia y lectoescritura'
}, {
  icon: '📖',
  number: 'Módulo 4',
  title: 'Lectoescritura Intensiva PRO',
  desc: 'Material secuenciado para avanzar en lectura, escritura y comprensión con mayor claridad y acompañamiento.',
  ideal: 'Dislexia y escritura'
}, {
  icon: '🔢',
  number: 'Módulo 5',
  title: 'Razonamiento Matemático PRO',
  desc: 'Actividades progresivas para trabajar número, lógica, relaciones y resolución de forma visual y concreta.',
  ideal: 'TDAH y desarrollo cognitivo'
}, {
  icon: '🧩',
  number: 'Módulo 6',
  title: 'Funciones Ejecutivas Estratégicas PRO',
  desc: 'Recursos específicos para fortalecer organización, planificación, flexibilidad y autocontrol.',
  ideal: 'TDAH, lectoescritura y aprendizaje'
}];
export function ProModules() {
  return <section className="py-20 bg-gray-900 text-white relative overflow-hidden" data-id="element-203">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-64 bg-brand-600 rounded-full blur-[120px] opacity-20" data-id="element-204"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-205">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-206">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-500/20 text-brand-300 font-bold text-sm mb-6 border border-brand-500/30" data-id="element-207">
            La oferta más fuerte · Incluye el Kit Profesional
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-4 tracking-tight" data-id="element-208">
            6 Módulos PRO ✍️
          </h2>
          <p className="text-xl text-gray-400" data-id="element-209">
            Material premium para potenciar cada área de tu intervención
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-210">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700 hover:border-brand-500 transition-colors" data-id="element-211">
              <div className="flex items-center gap-4 mb-6" data-id="element-212">
                <div className="text-4xl bg-gray-800 w-14 h-14 rounded-xl flex items-center justify-center shadow-inner border border-gray-700" data-id="element-213">
                  {mod.icon}
                </div>
                <div data-id="element-214">
                  <div className="text-brand-400 font-bold text-sm uppercase tracking-wider" data-id="element-215">
                    {mod.number}
                  </div>
                  <h3 className="text-lg font-bold text-white leading-tight" data-id="element-216">
                    {mod.title}
                  </h3>
                </div>
              </div>
              <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-217">
                {mod.desc}
              </p>
              <div className="bg-gray-900/80 rounded-lg p-3 border border-gray-800" data-id="element-218">
                <span className="text-gray-500 text-xs font-bold uppercase block mb-1" data-id="element-219">
                  Ideal para:
                </span>
                <span className="text-brand-300 text-sm font-medium" data-id="element-220">
                  {mod.ideal}
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-221">
          <div className="inline-block bg-brand-600 text-white font-bold px-6 py-3 rounded-full shadow-lg shadow-brand-600/20" data-id="element-222">
            Todo incluido en el Kit Profesional
          </div>
        </div>
      </div>
    </section>;
}